// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {getStorage} from "firebase/storage";
import {getAnalytics} from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB8M8z0uV5__GjZAAB1eMKDTwBtLqETOv4",
  authDomain: "ptshb-b1eb0.firebaseapp.com",
  projectId: "ptshb-b1eb0",
  storageBucket: "ptshb-b1eb0.firebasestorage.app",
  messagingSenderId: "768794260908",
  appId: "1:768794260908:web:f0732b3cf24efbcfd9f609",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);
